export default __webpack_public_path__ + "static/media/wildfire.c98069c3.jpg";